import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'

import COMPANY from '@/modules/settings/companySettings/queries/CompanyData.gql'

export function useCompanyQuery(auth) {
  const companyId = computed(() => auth.user?.companyId)

  const { result, loading, error, refetch } = useQuery(
    COMPANY,
    () => ({
      id: companyId.value,
    }),
    {
      enabled: computed(() => !!companyId.value),
    }
  )

  const company = computed(() => result.value?.company ?? null)

  return {
    company,
    loading,
    error,
    refetch,
  }
}
